import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-loader',
  templateUrl: './main-loader.component.html',
  styleUrls: ['./main-loader.component.css']
})
export class MainLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
